import { SelectOptionValue } from "@epcnetwork/core-ui-kit";

export const convertToNumber = (arr: SelectOptionValue[]) => {
  if (Array.isArray(arr)) {
    return arr?.map((item) => +item);
  }

  return [];
};
